export const lib = `define area deck;

move #2S deck[0,0];
move #3S deck[0,0];
move #4S deck[0,0];
move #5S deck[0,0];
move #6S deck[0,0];
move #7S deck[0,0];
move #8S deck[0,0];
move #9S deck[0,0];
move #10S deck[0,0];
move #JS deck[0,0];
move #QS deck[0,0];
move #KS deck[0,0];
move #AS deck[0,0];

move #2H deck[0,0];
move #3H deck[0,0];
move #4H deck[0,0];
move #5H deck[0,0];
move #6H deck[0,0];
move #7H deck[0,0];
move #8H deck[0,0];
move #9H deck[0,0];
move #10H deck[0,0];
move #JH deck[0,0];
move #QH deck[0,0];
move #KH deck[0,0];
move #AH deck[0,0];

move #2D deck[0,0];
move #3D deck[0,0];
move #4D deck[0,0];
move #5D deck[0,0];
move #6D deck[0,0];
move #7D deck[0,0];
move #8D deck[0,0];
move #9D deck[0,0];
move #10D deck[0,0];
move #JD deck[0,0];
move #QD deck[0,0];
move #KD deck[0,0];
move #AD deck[0,0];

move #2C deck[0,0];
move #3C deck[0,0];
move #4C deck[0,0];
move #5C deck[0,0];
move #6C deck[0,0];
move #7C deck[0,0];
move #8C deck[0,0];
move #9C deck[0,0];
move #10C deck[0,0];
move #JC deck[0,0];
move #QC deck[0,0];
move #KC deck[0,0];
move #AC deck[0,0];

shuffle();
`;